import React, { useMemo } from "react";
import {
  useAddPlantMutation,
  useDeletePlantMutation,
  useGetPlantsQuery,
  useUpdatePlantMutation,
} from "../../features/plants/plantApi";
import PlantValue from "../../components/ui/PlantValue";
import { getPlantCompactLabel } from "../../services/plantDisplay";
import { getLocalTimeZone, getTimeZoneOptions } from "../../services/timeZones";
import MasterCrudPage from "../masters/MasterCrudPage";
import { withAuditFilters } from "../masters/filterMetadata";

const Plant = () => {
  const timeZoneOptions = useMemo(() => getTimeZoneOptions(), []);
  const localTimeZone = useMemo(() => getLocalTimeZone(), []);
  const filterFields = useMemo(
    () =>
      withAuditFilters([
        { name: "plant_name", label: "Plant Name" },
        { name: "plant_code", label: "Plant Code" },
        {
          name: "time_zone_info",
          label: "Time Zone",
          type: "select",
          options: timeZoneOptions,
        },
      ]),
    [timeZoneOptions]
  );

  const fields = useMemo(
    () => [
      {
        name: "plant_name",
        label: "Plant Name",
        placeholder: "Enter plant name",
        required: true,
      },
      {
        name: "plant_code",
        label: "Plant Code",
        placeholder: "Enter plant code",
        required: true,
      },
      {
        name: "time_zone_info",
        label: "Time Zone",
        type: "select",
        options: timeZoneOptions,
        placeholder: "Select time zone",
        defaultValue: localTimeZone,
        required: true,
        fullWidth: true,
      },
    ],
    [localTimeZone, timeZoneOptions]
  );

  const columns = useMemo(
    () => [
      {
        name: "Plant",
        selector: (row) => getPlantCompactLabel(row, row?.plant_id),
        cell: (row) => <PlantValue plant={row} fallbackPlantId={row?.plant_id} />,
        sortable: true,
        grow: 2,
      },
      {
        name: "Time Zone",
        selector: (row) => row?.time_zone_info || "-",
        sortable: true,
        grow: 2,
      },
    ],
    []
  );

  return (
    <MasterCrudPage
      entityName="Plant"
      pageTitle="Plants"
      idField="plant_id"
      displayField="plant_name"
      fields={fields}
      columns={columns}
      searchFields={["plant_id", "plant_name", "plant_code", "time_zone_info"]}
      searchPlaceholder="Search plants"
      useListQuery={useGetPlantsQuery}
      useCreateMutation={useAddPlantMutation}
      useUpdateMutation={useUpdatePlantMutation}
      useDeleteMutation={useDeletePlantMutation}
      filterFields={filterFields}
      showPlantFilter={false}
      noDataLabel="No plants found"
    />
  );
};

export default Plant;
